import { tv, type VariantProps } from "@ui/lib/tv";

export const switchControl = tv({
  slots: {
    root: "group/switch flex cursor-pointer items-center gap-3 outline-none data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50",
    text: "flex flex-col",
    track: "flex h-7 w-12 shrink-0 items-center rounded-full bg-neutral-200 p-0.5 transition-colors",
    thumb: "size-6 rounded-full bg-white shadow-sm transition-transform",
    label: "text-base text-neutral-900 leading-6",
    description: "mt-1 text-base text-neutral-600 leading-6",
  },
  variants: {
    isHovered: { true: {} },
    isSelected: { true: { track: "bg-red-400", thumb: "translate-x-5" } },
    isFocusVisible: { true: { track: "outline-2 outline-red-300 outline-offset-2" } },
    layout: {
      inline: {},
      row: { root: "w-full justify-between gap-4", label: "font-bold" },
    },
  },
  compoundVariants: [{ isSelected: false, isHovered: true, class: { track: "bg-neutral-300" } }],
  defaultVariants: { layout: "inline" },
});

export type SwitchVariants = VariantProps<typeof switchControl>;
